import React, { useState, useRef, useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";

import InfoPopup from "../InfoPopup";

import Header from "./rentvine/Header";
import Content from "./rentvine/Content";
import Detail from "./rentvine/Details";

import toggleColorPicker from "../../Functions/toggleColorPicker";

const ListingsForRentvine = (props) => {
  const {
    widget: propsWidget,
    previewWidget,
    updateWrapperWidget,
    selectedEditor,
  } = props;
  const { htmlData } = propsWidget;

  const infoPopupRef = useRef(null);

  // Initialize state with default values or values from props
  const [widget, setWidget] = useState({
    htmlData: {
      rentvine: {
        rentvineUrl: decodeURIComponent(
          htmlData?.rentvine?.rentvineUrl ||
            "https://thirdstoneproperties.rentvine.com/api/public/listings"
        ),
        header: {
          rentvineHeading:
            htmlData?.rentvine?.header?.rentvineHeading ||
            "Find Your Dream Home",
          headercolor: htmlData?.rentvine?.header?.headercolor || "#ffffff",
          headerbg: htmlData?.rentvine?.header?.headerbg || "#232532",
          headerFontFamily:
            htmlData?.rentvine?.header?.headerFontFamily || "Montserrat",
          headerFontSize: htmlData?.rentvine?.header?.headerFontSize || "40",
          headerFontBold: htmlData?.rentvine?.header?.headerFontBold || "off",
          headerFontItalic:
            htmlData?.rentvine?.header?.headerFontItalic || "off",
        },
        layout: {
          layoutTemplate: htmlData?.rentvine?.layout?.layoutTemplate || "eagle",
          layoutFontFamily:
            htmlData?.rentvine?.layout?.layoutFontFamily || "Montserrat",
          layoutRent: htmlData?.rentvine?.layout?.layoutRent || "on",
          layoutDate: htmlData?.rentvine?.layout?.layoutDate || "on",
          layoutTitle: htmlData?.rentvine?.layout?.layoutTitle || "on",
          layoutAddress: htmlData?.rentvine?.layout?.layoutAddress || "on",
          layoutBeds: htmlData?.rentvine?.layout?.layoutBeds || "on",
          layoutBaths: htmlData?.rentvine?.layout?.layoutBaths || "on",
          layoutDetail: htmlData?.rentvine?.layout?.layoutDetail || "on",
          layoutApply: htmlData?.rentvine?.layout?.layoutApply || "on",
          layoutSectionBg:
            htmlData?.rentvine?.layout?.layoutSectionBg || "#e7f2ff",
          layoutRentColor:
            htmlData?.rentvine?.layout?.layoutRentColor || "#ffffff",
          layoutRentBg: htmlData?.rentvine?.layout?.layoutRentBg || "#598fcd",
          layoutDateColor:
            htmlData?.rentvine?.layout?.layoutDateColor || "#ffffff",
          layoutDateBg: htmlData?.rentvine?.layout?.layoutDateBg || "#598fcd",
          layoutTitleSize: htmlData?.rentvine?.layout?.layoutTitleSize || "18",
          layoutTitleColor:
            htmlData?.rentvine?.layout?.layoutTitleColor || "#000000",
          layoutAddressSize:
            htmlData?.rentvine?.layout?.layoutAddressSize || "14",
          layoutAddressColor:
            htmlData?.rentvine?.layout?.layoutAddressColor || "#000000",
          layoutBedColor:
            htmlData?.rentvine?.layout?.layoutBedColor || "#000000",
          layoutBedIconColor:
            htmlData?.rentvine?.layout?.layoutBedIconColor || "#000000",
          layoutBathColor:
            htmlData?.rentvine?.layout?.layoutBathColor || "#000000",
          layoutBathIconColor:
            htmlData?.rentvine?.layout?.layoutBathIconColor || "#000000",
          layoutDetailColor:
            htmlData?.rentvine?.layout?.layoutDetailColor || "#ffffff",
          layoutDetailBg:
            htmlData?.rentvine?.layout?.layoutDetailBg || "#27547c",
          layoutApplyColor:
            htmlData?.rentvine?.layout?.layoutApplyColor || "#ffffff",
          layoutApplyBg: htmlData?.rentvine?.layout?.layoutApplyBg || "#444444",
          layoutApplyLink: htmlData?.rentvine?.layout?.layoutApplyLink || "",
        },
        rentvineDisplayFilters: {
          search: htmlData.rentvine?.rentvineDisplayFilters?.search || "on",
          cats: htmlData.rentvine?.rentvineDisplayFilters?.cats || "off",
          dogs: htmlData.rentvine?.rentvineDisplayFilters?.dogs || "off",
          minRent: htmlData.rentvine?.rentvineDisplayFilters?.minRent || "on",
          maxRent: htmlData.rentvine?.rentvineDisplayFilters?.maxRent || "on",
          beds: htmlData.rentvine?.rentvineDisplayFilters?.beds || "on",
          baths: htmlData.rentvine?.rentvineDisplayFilters?.baths || "on",
          cities: htmlData.rentvine?.rentvineDisplayFilters?.cities || "on",
          zip: htmlData.rentvine?.rentvineDisplayFilters?.zip || "on",
          desiredMoveIn:
            htmlData.rentvine?.rentvineDisplayFilters?.desiredMoveIn || "off",
          sorting: htmlData.rentvine?.rentvineDisplayFilters?.sorting || "on",
        },
        detail: {
          detailOpenSeparate:
            htmlData?.rentvine?.detail?.detailOpenSeparate || "off",
          detailTemplate: htmlData?.rentvine?.detail?.detailTemplate || "half",
          detailSectionBg:
            htmlData?.rentvine?.detail?.detailSectionBg || "#ffffff",
          detailSectionTextColor:
            htmlData?.rentvine?.detail?.detailSectionTextColor || "#000000",
          detailSectionFF:
            htmlData?.rentvine?.detail?.detailSectionFF || "Montserrat",
          detailAddress: htmlData?.rentvine?.detail?.detailAddress || "on",
          detailPrice: htmlData?.rentvine?.detail?.detailPrice || "on",
          detailAvailable: htmlData?.rentvine?.detail?.detailAvailable || "on",
          detailPhone: htmlData?.rentvine?.detail?.detailPhone || "on",
          detailShowingBtn:
            htmlData?.rentvine?.detail?.detailShowingBtn || "on",
          detailApplyBtn: htmlData?.rentvine?.detail?.detailApplyBtn || "on",
          detailContactBtn:
            htmlData?.rentvine?.detail?.detailContactBtn || "on",
          detailAddressFontFamily:
            htmlData?.rentvine?.detail?.detailAddressFontFamily || "Montserrat",
          detailAddressFontSize:
            htmlData?.rentvine?.detail?.detailAddressFontSize || "22",
          detailAddressFontBold:
            htmlData?.rentvine?.detail?.detailAddressFontBold || "on",
          detailAddressColor:
            htmlData?.rentvine?.detail?.detailAddressColor || "#000000",
          detailPriceColor:
            htmlData?.rentvine?.detail?.detailPriceColor || "#000000",
          detailPriceFontFamily:
            htmlData?.rentvine?.detail?.detailPriceFontFamily || "Montserrat",
          detailPriceFontSize:
            htmlData?.rentvine?.detail?.detailPriceFontSize || "28",
          detailPriceFontBold:
            htmlData?.rentvine?.detail?.detailPriceFontBold || "on",
          detailAvailableColor:
            htmlData?.rentvine?.detail?.detailAvailableColor || "#000000",
          detailAvailableFontFamily:
            htmlData?.rentvine?.detail?.detailAvailableFontFamily ||
            "Montserrat",
          detailAvailableFontSize:
            htmlData?.rentvine?.detail?.detailAvailableFontSize || "28",
          detailAvailableFontBold:
            htmlData?.rentvine?.detail?.detailAvailableFontBold || "on",
          detailPhoneColor:
            htmlData?.rentvine?.detail?.detailPhoneColor || "#000000",
          detailPhoneFontFamily:
            htmlData?.rentvine?.detail?.detailPhoneFontFamily || "Montserrat",
          detailPhoneFontSize:
            htmlData?.rentvine?.detail?.detailPhoneFontSize || "18",
          detailPhoneFontBold:
            htmlData?.rentvine?.detail?.detailPhoneFontBold || "on",
          detailShowingColor:
            htmlData?.rentvine?.detail?.detailShowingColor || "#ffffff",
          detailShowingBg:
            htmlData?.rentvine?.detail?.detailShowingBg || "#598fcd",
          detailShowingFontFamily:
            htmlData?.rentvine?.detail?.detailShowingFontFamily || "Montserrat",
          detailShowingFontSize:
            htmlData?.rentvine?.detail?.detailShowingFontSize || "16",
          detailShowingFontBold:
            htmlData?.rentvine?.detail?.detailShowingFontBold || "off",
          detailApplyColor:
            htmlData?.rentvine?.detail?.detailApplyColor || "#ffffff",
          detailApplyBg: htmlData?.rentvine?.detail?.detailApplyBg || "#598fcd",
          detailApplyFontFamily:
            htmlData?.rentvine?.detail?.detailApplyFontFamily || "Montserrat",
          detailApplyFontSize:
            htmlData?.rentvine?.detail?.detailApplyFontSize || "16",
          detailApplyFontBold:
            htmlData?.rentvine?.detail?.detailApplyFontBold || "off",
          detailContactColor:
            htmlData?.rentvine?.detail?.detailContactColor || "#ffffff",
          detailContactBg:
            htmlData?.rentvine?.detail?.detailContactBg || "#598fcd",
          detailContactFontFamily:
            htmlData?.rentvine?.detail?.detailContactFontFamily || "Montserrat",
          detailContactFontSize:
            htmlData?.rentvine?.detail?.detailContactFontSize || "16",
          detailContactFontBold:
            htmlData?.rentvine?.detail?.detailContactFontBold || "off",
        },
        rentvineSortOrder:
          htmlData?.rentvine?.rentvineSortOrder || "date_posted",
        renttvineCol: htmlData?.rentvine?.renttvineCol || "3",
        clientGmapApi: htmlData?.rentvine?.clientGmapApi || "",
        group: htmlData?.rentvine?.group || "",
      },
    },
    widgetType: propsWidget.widgetType.id,
    widgetTypeName: propsWidget.widgetType.name,
    title: propsWidget.title ? propsWidget.title : "",
    expires: propsWidget.expires ? propsWidget.expires : "",
    isUrlChanged: true,
  });

  // Handle input changes
  const handleInputChange = async (e) => {
    const { type, name, value, checked } = e.target;
  
    // Create the updated widget state first before setting it
    const isUrlRelated = name === "rentvineUrl" || name === "clientGmapApi" || name === "group";
    
    const newWidget = {
      ...widget,
      [name]: value,
      isUrlChanged: isUrlRelated ? true : false,
      htmlData: {
        ...widget.htmlData,
        rentvine: {
          ...widget.htmlData.rentvine,
          [name]: value,
          header: {
            ...widget.htmlData.rentvine.header,
            [name]: type === "checkbox" ? (checked ? "on" : "off") : value,
          },
          layout: {
            ...widget.htmlData.rentvine.layout,
            [name]: type === "checkbox" ? (checked ? "on" : "off") : value,
          },
          rentvineDisplayFilters: {
            ...widget.htmlData.rentvine.rentvineDisplayFilters,
            [name]: checked ? "on" : "off",
          },
          detail: {
            ...widget.htmlData.rentvine.detail,
            [name]: type === "checkbox" ? (checked ? "on" : "off") : value,
          },
        },
      },
    };
    
    // Update state
    setWidget(newWidget);
    
    // Handle sort order
    if (name === "rentvineSortOrder") {
      const filterSort = document.querySelector("#filterSort");
      if (filterSort) {
        filterSort.value = value;
        const event = new Event("change");
        filterSort.dispatchEvent(event);
      }
    }
  
    // Use the new widget object directly for preview
    const rvURL = newWidget.htmlData.rentvine.rentvineUrl;
    if (rvURL) {
      await previewWidget(newWidget);
    } else {
      await updateWrapperWidget(newWidget);
    }
  };

  const loadPreview = async () => {
    const rvURL = widget.htmlData.rentvine.rentvineUrl;
    if (rvURL) {
      await previewWidget(widget);
    }
  };
  // Component did mount equivalent
  useEffect(() => {
    loadPreview();
  }, [widget]);

  // Handler for color pickers
  const setColorsAndPreview = async (section, stateItem, value) => {
    // Create new widget with updated color value
    const newWidget = {
      ...widget,
      isUrlChanged: false,
      htmlData: {
        ...widget.htmlData,
        rentvine: {
          ...widget.htmlData.rentvine,
          [section]: {
            ...widget.htmlData.rentvine[section],
            [stateItem]: value,
          },
        },
      },
    };
    
    // Update state
    setWidget(newWidget);
  
    // Preview with the new widget directly
    const rvURL = newWidget.htmlData.rentvine.rentvineUrl;
    if (rvURL) {
      await previewWidget(newWidget);
    }
  };  

  // Google API steps content
  const gApiSteps = `
    <h2>Step-by-Step Guide to Add Your Domain to Allowed Referrers:</h2>
    <ol>
    <li>Go to the Google Cloud Console: Navigate to the Google Cloud Console.
    <li>Select Your Project: Make sure you have the correct project selected from the project dropdown menu at the top of the page.
    <li>Access API & Services: Click on the "Navigation Menu" (three horizontal lines in the top-left corner), then select "APIs & Services" > "Credentials."
    <li>Identify Your API Key: In the "Credentials" page, you will see a list of API keys. Find the API key you are using for the Maps JavaScript API.
    <li>Edit API Key: Click on the name of your API key to edit its settings.
    <li>Application Restrictions: Scroll down to the "Application restrictions" section. Select "HTTP referrers (websites)" to restrict the usage of the API key to specific websites.
    <li>Add Your Domain: Under "Website restrictions," click "Add an item" and enter your domain in the format specified (e.g., example.com/* for a broad match or https://www.example.com/specificpage for a more specific path).
    <li>Note: Ensure you include all variations of your domain that your application might use, including with or without www, different subdomains, or any specific paths, if applicable.
    <li>Save Changes: After adding your domain(s), click the "Save" button at the bottom of the page to apply your changes.
    </ol>
    `;

  const { title } = widget;
  const { rentvine } = widget.htmlData;

  return (
    <div className="mjwi-editor-main-inner">
      {selectedEditor === "Builder" && (
        <div className="mjwi-editor-builder">
          <label htmlFor="title">Widget Name</label>
          <input
            type="text"
            name="title"
            value={title}
            placeholder="Title"
            onChange={handleInputChange}
          />

          <label htmlFor="rentvineUrl">Rentvine Listings URL</label>
          <input
            type="text"
            name="rentvineUrl"
            value={rentvine.rentvineUrl}
            placeholder="https://thirdstoneproperties.rentvine.com/api/public/listings"
            onChange={handleInputChange}
          />

          <label htmlFor="clientGmapApi">
            Google Map API Key{" "}
            <i
              onClick={() => infoPopupRef.current.openPopup()}
              className="fa-solid fa-circle-info"
            ></i>
          </label>
          <input
            type="text"
            name="clientGmapApi"
            value={rentvine.clientGmapApi}
            onChange={handleInputChange}
          />

          <label>Group</label>
          <input
            type="text"
            name="group"
            value={rentvine.group}
            onChange={handleInputChange}
          />

          <InfoPopup ref={infoPopupRef} info={gApiSteps} />
        </div>
      )}

      {selectedEditor === "Layout" && (
        <div className="mjwi-editor-layout">
          <Accordion allowZeroExpanded={true}>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>Top Banner</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <Header
                  widget={widget}
                  handleInputChange={handleInputChange}
                  toggleColorPicker={toggleColorPicker}
                  setColorsAndPreview={setColorsAndPreview}
                />
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>All Listings Page</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <Content
                  widget={widget}
                  handleInputChange={handleInputChange}
                  toggleColorPicker={toggleColorPicker}
                  setColorsAndPreview={setColorsAndPreview}
                />
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>Single Listing Page</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <Detail
                  widget={widget}
                  handleInputChange={handleInputChange}
                  toggleColorPicker={toggleColorPicker}
                  setColorsAndPreview={setColorsAndPreview}
                />
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        </div>
      )}
    </div>
  );
};

export default ListingsForRentvine;
